// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-textarea[data-v-273d59e0]  .v-input__control>.v-input__slot{background-color:var(--v-grayDarkest-lighten2)!important;min-height:32px}.input-textarea[data-v-273d59e0]  .v-input__control>.v-input__slot:after,.input-textarea[data-v-273d59e0]  .v-input__control>.v-input__slot:before{display:none}.input-textarea[data-v-273d59e0]  textarea{line-height:inherit}.input-bottom[data-v-273d59e0]{background-color:var(--v-grayDarkest-lighten2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
